import StudentCourseDetailsPage from './StudentCourseDetailsPage';
import { StudentCourseDetailsPageProps, StudentCourseDetailsPageValueProps } from './types';

export type { StudentCourseDetailsPageProps, StudentCourseDetailsPageValueProps };
export default StudentCourseDetailsPage;
